import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startUpateComment = () =>
  produce((draft: Draft<State>) => {
    draft.updateComment.fetching = initialState.updateComment.fetching + 1;
  });

export const finishUpdateComment = () =>
  produce((draft: Draft<State>) => {
    draft.updateComment.fetching = initialState.updateComment.fetching - 1;
  });
